import React from "react";
import {
  IconReply,
  MESSAGE_ACTIONS,
  MessageActions,
  QuickMessageActionsButton,
  defaultMessageActionSet,
  useMessageComposerController,
  useMessageContext,
  useTranslationContext,
} from "stream-chat-react";

function focusMessageComposerTextarea(message) {
  const elements = message?.parent_id
    ? document.querySelectorAll(".str-chat__thread .str-chat__textarea__textarea")
    : document.getElementsByClassName("str-chat__textarea__textarea");
  const textarea = elements.item(0);
  if (textarea instanceof HTMLTextAreaElement) {
    textarea.focus();
  }
}

function QuickQuoteReply() {
  const { message } = useMessageContext();
  const { t } = useTranslationContext();
  const messageComposer = useMessageComposerController();

  return (
    <QuickMessageActionsButton
      aria-label={t("aria/Quote Message")}
      className="str-chat__message-reply-in-thread-button"
      data-testid="quote-action"
      onClick={() => {
        messageComposer.setQuotedMessage(message);
        focusMessageComposerTextarea(message);
      }}
    >
      <IconReply className="str-chat__message-action-icon" />
    </QuickMessageActionsButton>
  );
}

const quoteReplyMessageActionSet = defaultMessageActionSet
  .filter((action) => !(action.placement === "dropdown" && action.type === "reply"))
  .map((action) => {
    if (action.placement === "quick" && action.type === "reply") {
      return {
        ...action,
        Component: QuickQuoteReply,
        type: "quote",
      };
    }
    return action;
  });

export const channelMessageActions = Object.keys(MESSAGE_ACTIONS).filter(
  (action) => action !== "reply"
);

export default function QuoteReplyMessageActions() {
  return <MessageActions messageActionSet={quoteReplyMessageActionSet} />;
}
